import React, {useState} from 'react'
import ProfileImg from '../assets/icons/User_24px.svg'
import LogoutImg from '../assets/icons/logout.svg'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Dropdown } from 'react-bootstrap';
import userAvtar from '../assets/icons/Avatar.png';
import { Modal, Button } from 'react-bootstrap';
import LogoutPic from '../assets/icons/logout-img.svg'

function UserProfileDropdown() {
    const { logout, username, userRole } = useAuth();
    const navigate = useNavigate();
    const [showLogOutModal, setShowLogOutModal] = useState(false);

    const handleLogout = () => {
        logout();
        navigate('/');
    };
    const handleLogoutClick = () => {
        setShowLogOutModal(true);
    };
    return (
        <>
        <Dropdown className="ms-auto">
            <Dropdown.Toggle variant="link" id="dropdown-basic" className="p-0">
                <img src={userAvtar}
                    alt="User Avatar" className="user-avatar" width={48} height={48} />
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu-right">
                <Dropdown.ItemText>
                    <div className="d-flex align-items-center">
                        <img src={userAvtar}
                            alt="User Avatar" className="user-avatar" />
                        <div>
                            <h6 className="mb-0 user-name">{username}</h6>
                            <p className="mb-0 user-role">{userRole}</p>
                        </div>
                    </div>
                </Dropdown.ItemText>
                <Dropdown.Divider className='m-0' />
                <Dropdown.Item href="/profile" className='profile-opt'>
                    <img src={ProfileImg}
                        alt="User Avatar" className="profile-avatar me-2" width={'24px'} height={'24px'} /> Profile</Dropdown.Item>
                <Dropdown.Divider className='m-0' />
                <Dropdown.Item onClick={() => handleLogoutClick()} className='logout-opt'><img src={LogoutImg}
                    alt="User Avatar" className="logout-avatar me-2" width={'24px'} height={'24px'} />Logout</Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
        <Modal show={showLogOutModal} onHide={() => setShowLogOutModal(false)} className='confirm-logout-modal'>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className='d-flex flex-column align-items-center text-center'>
                    <img src={LogoutPic} alt='user-logout' className='logout-img'></img>
                    <p className='confirm-text'>
                    Are you sure you want to sign out?
                    </p>
                    <small className='confirm-sub-text'>Please ensure all changes have been 
                    saved before proceeding.</small>
                    
                </Modal.Body>
                <Modal.Footer>
                    <button  onClick={() => {
                        setShowLogOutModal(false);
                    }} className='cancel-btn'>
                        Cancel
                    </button>
                    <button className='logout-btn' onClick={handleLogout}>
                        Log Out
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default UserProfileDropdown